import React from 'react';
import useNcziPatientAutoVerify from '../../Hooks/useNcziPatientAutoVerify';
import { usePatientTreatmentContext } from '../../../Patient/Components/PatientTreatment/ContextProvider';
import PatientNonPayerModal from '../PatientInsuranceSetup/PatientNonPayerModal';
import PatientAutoVerifyErrorModal from './PatientAutoVerifyErrorModal';
import PatientAutoVerifyMismatchModal from './PatientAutoVerifyMismatchModal';
import PatientAutoVerifyNotInsuredModal from './PatientAutoVerifyNotInsuredModal';

interface Props {
	justAssigned?: boolean;
}

const PatientAutoVerify: React.FC<Props> = ({ justAssigned = false }) => {
	const { patientId } = usePatientTreatmentContext();
	const { activeDialog, mismatchKeys, errorMessage, closeDialog, retry } =
		useNcziPatientAutoVerify(justAssigned);

	if (!activeDialog) {
		return <></>;
	}

	return (
		<>
			{activeDialog === 'mismatch' && (
				<PatientAutoVerifyMismatchModal
					isOpen
					patientId={patientId}
					mismatchKeys={mismatchKeys}
					onClose={closeDialog}
				/>
			)}
			{activeDialog === 'error' && (
				<PatientAutoVerifyErrorModal
					isOpen
					errorMessage={errorMessage}
					onRetry={retry}
					onClose={closeDialog}
				/>
			)}
			{activeDialog === 'nonPayer' && (
				<PatientNonPayerModal opened onClose={closeDialog} />
			)}
			{activeDialog === 'notInsured' && (
				<PatientAutoVerifyNotInsuredModal isOpen onClose={closeDialog} />
			)}
		</>
	);
};

export default PatientAutoVerify;
